// Champ code promo (PR-1756) : applique le code au panier par l'API Ajax (/cart/update.js, paramètre discount).
// Repli si l'API ne rend pas discount_codes : /discount/<code>?redirect=<panier>.
if (!customElements.get('code-promo')) {
  customElements.define(
    'code-promo',
    class CodePromo extends HTMLElement {
      connectedCallback() {
        this.racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.panier = (window.routes && window.routes.cart_url) || this.racine + 'cart';
        this.input = this.querySelector('input');
        this.bouton = this.querySelector('button[type="submit"]');
        this.message = this.querySelector('.code-promo__message');
        this.querySelector('form').addEventListener('submit', (e) => {
          e.preventDefault();
          this.appliquer(this.input.value.trim());
        });
        this.liste = this.querySelector('.code-promo__codes');
        this.liste.addEventListener('click', (e) => {
          const b = e.target.closest('[data-retirer]');
          if (b) this.retirer(b.dataset.retirer);
        });
        this.majCodes();
        // Panier modifié ailleurs (ajout au panier, quantités) : puces relues.
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.majCodes());
      }

      // Puces des codes appliqués, lues dans /cart.js (à jour même si la fenêtre a été rendue panier vide).
      async majCodes() {
        try {
          const codes = this.valides(await this.lirePanier());
          this.liste.replaceChildren(
            ...codes.map((c) => {
              const li = document.createElement('li');
              li.className = 'code-promo__code';
              const b = document.createElement('button');
              b.type = 'button';
              b.dataset.retirer = c;
              b.setAttribute('aria-label', `Retirer le code ${c}`);
              b.textContent = '×';
              li.append(c, b);
              return li;
            })
          );
          this.liste.hidden = codes.length === 0;
        } catch (e) {}
      }

      dire(texte) {
        this.message.textContent = texte;
      }

      async lirePanier() {
        const r = await fetch(this.racine + 'cart.js', { headers: { Accept: 'application/json' } });
        return r.json();
      }

      async ecrireCodes(codes) {
        const r = await fetch(this.racine + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }),
        });
        if (!r.ok) throw new Error('cart/update ' + r.status);
        return r.json();
      }

      valides(panier) {
        return (panier.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
      }

      versPanier() {
        if (window.location.pathname === new URL(this.panier, window.location.origin).pathname) window.location.reload();
        else window.location.href = this.panier;
      }

      async appliquer(code) {
        if (!code) return this.dire('Saisissez un code promo.');
        this.bouton.disabled = true;
        this.dire('Vérification du code…');
        try {
          const avant = this.valides(await this.lirePanier());
          if (avant.some((c) => c.toLowerCase() === code.toLowerCase())) {
            this.bouton.disabled = false;
            return this.dire(`Le code « ${code} » est déjà appliqué.`);
          }
          const apres = await this.ecrireCodes([...avant, code]);
          if (!Array.isArray(apres.discount_codes)) throw new Error('discount_codes absent');
          const trouve = apres.discount_codes.find((d) => d.code.toLowerCase() === code.toLowerCase());
          if (trouve && trouve.applicable) return this.versPanier();
          await this.ecrireCodes(avant);
          this.dire(`Le code « ${code} » n'est pas valable pour ce panier.`);
        } catch (e) {
          window.location.href =
            this.racine + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(this.panier);
          return;
        }
        this.bouton.disabled = false;
      }

      async retirer(code) {
        try {
          const avant = this.valides(await this.lirePanier());
          await this.ecrireCodes(avant.filter((c) => c.toLowerCase() !== code.toLowerCase()));
        } finally {
          this.versPanier();
        }
      }
    }
  );
}
